import script from "./FordRedisAdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FordRedisAdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./FordRedisAdminPanel.vue?vue&type=style&index=0&id=d97c2bc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d97c2bc2"]])

export default __exports__